<div class="p-booking-info-mdl__item">
  <button
    id="passenger-info-open-button"
    [ngClass]="['p-booking-info-mdl__open', isOpen ? 'is-open' : '']"
    aria-controls="drawer-passenger-information"
    [attr.aria-expanded]="isOpen"
    (click)="onClickShutter()"
  >
    <span class="p-booking-info-mdl__open-head">
      <!-- [4.1] 搭乗者姓名-->
      <span class="p-booking-info-mdl__open-title" [innerHTML]="parts?.passengerName"></span>
      <!-- [4.2] 搭乗者種別-->
      <span class="p-booking-info-mdl__open-subtext" [innerHTML]="passengerTypeLabel"></span>
    </span>
    <!-- [4.3] 編集中表示 & (4.4) 開く -->
    <span
      *ngIf="parts?.registrationLabel"
      [ngClass]="['p-booking-info-mdl__open-state', parts?.registrationClass]"
      [innerHTML]="registrationLabel"
    ></span>
    <span class="u-visually-hidden" [innerHTML]="parts?.passengerName"></span>
  </button>
  <!-- [1.6] 搭乗者情報詳細 -->
  <div
    *ngIf="renderComponent || isOpen"
    id="drawer-passenger-information"
    [ngClass]="['p-booking-info-mdl__contents', isOpen ? 'is-open' : '']"
  >
    <div class="p-booking-info-mdl__item-head">
      <div class="p-booking-info-mdl__item-head-wrap">
        <!-- [4.1] 搭乗者姓名-->
        <h2 class="p-booking-info-mdl__item-head-title" [innerHTML]="parts?.passengerName"></h2>
        <!-- [4.2] 搭乗者種別-->
        <div class="p-booking-info-mdl__item-head-subtext" [innerHTML]="passengerTypeLabel"></div>
      </div>
      <!-- [4.3] 編集中表示 -->
      <div
        class="p-booking-info-mdl__item-head-status p-booking-info-mdl__open-state--editing"
        [innerHTML]="registrationLabel"
      ></div>
    </div>
    <!-- [1.7] 予約基本情報(搭乗者) -->
    <div
      *ngIf="memberInformation && parts?.isDisplayBasicReservation && isNotPassengerINF && isDisplaySupportInfoLabel"
      class="p-booking-info-mdl__usual"
    >
      <div class="c-usual-information01">
        <h3 class="c-usual-information01__title" [innerHTML]="'label.usualInformation' | staticMsg"></h3>
        <!-- [6.1] 予約基本情報サマリ(搭乗者) -->
        <div
          *ngIf="!parts?.isOpenBasicReservationDetails; else usualInformationBody"
          class="c-usual-information01__details"
        >
          <div class="c-usual-information01__details-list">
            <ul class="c-check-list01">
              <!-- [6.4] サポート情報 -->
              <li class="c-check-list01__item" *ngIf="isDisplaySupportInfoLabel">
                <span class="c-check-list01__text" [innerHTML]="'label.supportInformation' | staticMsg"></span>
              </li>
            </ul>
          </div>
          <div class="c-usual-information01__details-btn">
            <!-- [6.5] 予約基本情報詳細(搭乗者)表示ボタン -->
            <asw-button
              type="secondary"
              size="xs"
              [label]="'label.openUsualInfo' | staticMsg"
              (click$)="onClickCheckDetails()"
            ></asw-button>
          </div>
        </div>
        <!-- [6.6] 予約基本情報詳細(搭乗者) -->
        <ng-template #usualInformationBody>
          <div class="c-usual-information01__body">
            <dl class="c-def-list01">
              <!-- [6.18] サポート情報 -->
              <ng-container *ngIf="isDisplaySupportInfoLabel">
                <div class="c-def-list01__item">
                  <dt class="c-def-list01__item-title" [innerHTML]="'label.degreeOfWalking' | staticMsg"></dt>
                  <dd class="c-def-list01__item-body">
                    <dl class="c-float-list01">
                      <!-- [6.19] 歩行の程度 -->
                      <div class="c-float-list01__item">
                        <dt class="c-float-list01__title" [innerHTML]="'label.walking.ability' | staticMsg"></dt>
                        <dd
                          class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                          [innerHTML]="walkingAbilityDisplay"
                        ></dd>
                      </div>
                      <ng-container *ngIf="wheelchairIsNeeded">
                        <!-- [6.20] 車いす有無 -->
                        <div class="c-float-list01__item">
                          <dt class="c-float-list01__title" [innerHTML]="'label.useWheelchair' | staticMsg"></dt>
                          <dd
                            class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                            [innerHTML]="getWheelchairAvailability"
                          ></dd>
                        </div>
                        <!-- [6.21] 車いす折りたたみ -->
                        <div class="c-float-list01__item">
                          <dt class="c-float-list01__title" [innerHTML]="'label.foldingWheelchair' | staticMsg"></dt>
                          <dd
                            class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                            [innerHTML]="getStatusFoldingWheelchair"
                          ></dd>
                        </div>
                        <!-- [6.22] 車いすサイズ情報 -->
                        <div class="c-float-list01__item">
                          <dt class="c-float-list01__title" [innerHTML]="'label.size' | staticMsg"></dt>
                          <dd
                            class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                            [innerHTML]="wheelchairSizeLabel"
                          ></dd>
                        </div>
                        <!-- [6.23] 車いすサイズ(重さ) -->
                        <div class="c-float-list01__item">
                          <dt class="c-float-list01__title" [innerHTML]="'label.weight' | staticMsg"></dt>
                          <dd
                            class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                            [innerHTML]="wheelchairWeightLabel"
                          ></dd>
                        </div>
                        <!-- [6.24] 車いす種類 -->
                        <div class="c-float-list01__item">
                          <dt class="c-float-list01__title" [innerHTML]="'label.wheelchairType' | staticMsg"></dt>
                          <dd
                            class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                            [innerHTML]="getWheelchairType"
                          ></dd>
                        </div>
                        <!-- [6.25] バッテリータイプ -->
                        <div class="c-float-list01__item">
                          <dt class="c-float-list01__title" [innerHTML]="'label.batteryType' | staticMsg"></dt>
                          <dd
                            class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                            [innerHTML]="batteryTypeDisplay"
                          ></dd>
                        </div>
                      </ng-container>
                    </dl>
                  </dd>
                </div>
                <!-- [6.26] 視覚障がい -->
                <div class="c-def-list01__item c-def-list01__item--one">
                  <dt class="c-def-list01__item-title" [innerHTML]="'label.blind' | staticMsg"></dt>
                  <dd class="c-def-list01__item-body" [innerHTML]="getBlindLabel"></dd>
                </div>
                <!-- [6.27] 聴覚障がい -->
                <div class="c-def-list01__item c-def-list01__item--one">
                  <dt class="c-def-list01__item-title" [innerHTML]="'label.deaf' | staticMsg"></dt>
                  <dd class="c-def-list01__item-body" [innerHTML]="getDeafLabel"></dd>
                </div>
              </ng-container>
            </dl>
          </div>
          <div class="c-usual-information01__btn c-usual-information01__btn--mt16">
            <!-- [6.28] キャンセル -->
            <asw-button
              type="tertiary"
              size="s"
              [label]="'label.closeUsualInfo' | staticMsg"
              (click$)="onClickCheckDetails()"
            ></asw-button>
            <!-- [6.29] 反映(搭乗者情報) -->
            <asw-button
              *ngIf="isDisplayReflectBtn"
              type="primary"
              size="s"
              [label]="'label.enter' | staticMsg"
              (click$)="onClickEnterUsualInfo()"
            ></asw-button>
          </div>
        </ng-template>
      </div>
    </div>
    <!-- [1.8] 搭乗者基本情報  -->
    <div *ngIf="parts?.isDisplayBasicInformation" class="p-booking-info-mdl__section">
      <div *ngIf="data?.basicInformation?.age" class="p-booking-info-mdl__block">
        <div class="p-booking-info-mdl__heading p-booking-info-mdl__heading--01">
          <h3 class="p-booking-info-mdl__heading-title" [innerHTML]="'label.ageverification' | staticMsg"></h3>
        </div>
        <div class="p-booking-info-mdl__row p-booking-info-mdl__row--01">
          <div class="p-booking-info-mdl__row-item">
            <dl class="c-float-list01">
              <!-- [5.1] 年齢 -->
              <div class="c-float-list01__item">
                <dt
                  class="c-float-list01__title"
                  [innerHTML]="'label.age' | staticMsg"
                  [attr.aria-labelledby]="'reader.age' | staticMsg"
                ></dt>
                <dd
                  class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                  [innerHTML]="data?.basicInformation?.age"
                ></dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
      <div class="p-booking-info-mdl__block p-booking-info-mdl__block--01">
        <div class="p-booking-info-mdl__heading p-booking-info-mdl__heading--02">
          <h4 class="p-booking-info-mdl__heading-title" [innerHTML]="'label.dateOfBirth' | staticMsg"></h4>
          <span class="c-label-required" [innerHTML]="'message.mandatory' | staticMsg"></span>
        </div>
        <div class="p-booking-info-mdl__row p-booking-info-mdl__row--mb16">
          <div class="p-booking-info-mdl__row-item">
            <div class="c-form-element-select is-selected">
              <!-- [5.2] 生年月日-->
              <asw-select-date-ymd
                order="YMD"
                [dateFrom]="birthdayDateFrom"
                [dateTo]="birthdayDateTo"
                [initialDate]="birthdayInitialDate"
                [errorMessage]="birthDateErrorMsg"
                (selectedDateChange)="onChangeBirthday($event)"
                [altLabels]="['label.dateOfBirth.year', 'label.dateOfBirth.month', 'label.dateOfBirth.day']"
              ></asw-select-date-ymd>
            </div>
          </div>
        </div>
      </div>
    </div>
    <form [formGroup]="formGroup">
      <!-- [1.10] 搭乗者連絡先情報 -->
      <div *ngIf="isNotPassengerINF" class="p-booking-info-mdl__section">
        <div class="p-booking-info-mdl__block">
          <div class="p-booking-info-mdl__heading p-booking-info-mdl__heading--01">
            <h3
              class="p-booking-info-mdl__heading-title"
              [innerHTML]="'label.passengerContactInformation' | staticMsg"
            ></h3>
          </div>
          <div class="p-booking-info-mdl__heading p-booking-info-mdl__heading--02">
            <h4 class="p-booking-info-mdl__heading-title">
              <!-- [8.1] 搭乗者メール送信先の見出し -->
              <span class="c-text-with-tooltip">
                <span class="c-text-with-tooltip__text"> {{ getNotificationEmail() | staticMsg }}</span>
                <!-- [8.2] ヘルプアイコン ※搭乗者メール送信先の見出し -->
                <span class="c-text-with-tooltip__tooltip js-tooltip">
                  <asw-tooltip
                    iconImage="<img src=&quot;assets/images/icon_help_primary_20.svg&quot; alt={{
                      'm_static_message-alt.helpIcon2' | staticMsg
                    }} width=&quot;20&quot; height=&quot;20&quot;>"
                    [tooltipContent]="getTooltipEmail | staticMsg"
                    [displayAreaClass]="'p-booking-info-mdl__contents'"
                  ></asw-tooltip>
                </span>
              </span>
            </h4>
          </div>
          <div
            class="p-booking-info-mdl__row"
            *ngIf="isDisplayPassengerEmailDestination && parts?.isPassengerEmailEditable"
          >
            <div class="p-booking-info-mdl__row-item">
              <!-- [8.3] 搭乗者メール送信先 -->
              <asw-radio-group
                [formControlName]="PASSENGER_FORMS.MAIL_DESTINATION"
                (change$)="onChangeMailDestination()"
                direction="sp-vertical"
              >
                <asw-radio-button
                  *ngIf="isDisplaySendToRrepresentativeMailAddress()"
                  value="0"
                  [label]="'label.sendToRrepresentativeMailAddress' | staticMsg"
                ></asw-radio-button>
                <asw-radio-button value="1" [label]="'label.specifyPerPassenger' | staticMsg"></asw-radio-button>
              </asw-radio-group>
            </div>
          </div>
        </div>
        <div *ngIf="isDisplaySendMail" class="p-booking-info-mdl__block p-booking-info-mdl__block--top0">
          <div class="p-booking-info-mdl__heading p-booking-info-mdl__heading--02">
            <h4 class="p-booking-info-mdl__heading-title" [innerHTML]="'label.eMail.passengerInput' | staticMsg"></h4>
            <span class="c-label-required" [innerHTML]="'message.mandatory' | staticMsg"></span>
          </div>
          <ng-container *ngIf="parts?.isPassengerEmailEditable; else readonlyPassengerEmail">
            <div class="p-booking-info-mdl__row p-booking-info-mdl__row--01">
              <div class="p-booking-info-mdl__row-item">
                <!-- [8.4] 搭乗者メールアドレス -->
                <asw-input
                  [label]="'label.eMailAddress.passengerInput' | staticMsg"
                  [placeholder]="'placeholder.eMailAddress' | staticMsg"
                  [formControlName]="PASSENGER_FORMS.MAIL_ADDRESS"
                  (change$)="update()"
                  maxlength="50"
                  [conversionType]="'email'"
                ></asw-input>
              </div>
            </div>
            <div class="p-booking-info-mdl__row p-booking-info-mdl__row--01">
              <div class="p-booking-info-mdl__row-item">
                <!-- [8.5] 搭乗者メールアドレス(確認用) -->
                <asw-input
                  [label]="'label.confirmMailAddress' | staticMsg"
                  [placeholder]="'placeholder.eMailAddress' | staticMsg"
                  [formControlName]="PASSENGER_FORMS.MAIL_ADDRESS_CONFIRM"
                  (change$)="update()"
                  maxlength="50"
                  [conversionType]="'email'"
                  disablePaste
                ></asw-input>
              </div>
            </div>
          </ng-container>
          <ng-template #readonlyPassengerEmail>
            <div class="p-booking-info-mdl__row p-booking-info-mdl__row--01">
              <div class="c-float-list01" *ngFor="let travelerEmail of travelerContacts?.emails">
                <div class="c-float-list01__item">
                  <div
                    class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                    [innerHTML]="travelerEmail?.address"
                  ></div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </form>
    <!-- [1.11] 追加情報 -->
    <div class="p-booking-info-mdl__section p-booking-info-mdl__section--pb0">
      <div class="p-booking-info-mdl__block">
        <div
          class="p-booking-info-mdl__heading p-booking-info-mdl__heading--01 p-booking-info-mdl__heading--additional"
        >
          <h3 class="p-booking-info-mdl__heading-title" [innerHTML]="'label.additionalInformation' | staticMsg"></h3>
        </div>
        <div class="p-booking-info-mdl__additional">
          <!-- [1.14] 発着通知連絡先情報 -->
          <asw-arrival-departure-notice-information
            #arrivalDepartureNoticeInfoComponent
            *ngIf="parts?.isDisplayArrivalDepartureNotify && isNotPassengerINF"
            [data]="data?.arrivalAndDepartureNotice"
            [parts]="parts?.arrivalDepartureNoticeInformationParts"
            (dataChange)="onAdditionDataChange()"
          ></asw-arrival-departure-notice-information>
          <!-- [1.15] サポート情報表示 -->
          <asw-support-information
            #supportInfoComponent
            *ngIf="isDisplaySupportInfo && isNotPassengerINF"
            [data]="data?.support"
            [parts]="parts?.supportInformationParts"
            (dataChange)="onAdditionDataChange()"
            [travelerId]="data?.travelerId"
          ></asw-support-information>
        </div>
      </div>
    </div>

    <div class="p-booking-info-mdl__section">
      <div class="p-booking-info-mdl__block">
        <div class="p-booking-info-mdl__close">
          <button
            id="passenger-info-close-button"
            class="p-booking-info-mdl__close-btn"
            aria-controls="drawer-passenger-information"
            aria-expanded="true"
            (click)="onClickShutter()"
          >
            <span class="p-booking-info-mdl__close-text" [innerHTML]="'label.fold' | staticMsg"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
